import { render } from "./PostComments.vue?vue&type=template&id=d06257a8"
import script from "./PostComments.vue?vue&type=script&lang=js"
export * from "./PostComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__